function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#3EB1C8",
  fillRule: "nonzero",
  stroke: "#00B3CA",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 11c-2.778 0-5-2.26-5-5 0-2.778 2.26-5 5-5 2.778 0 5 2.26 5 5s-2.222 5-5 5zm0-9.167a4.158 4.158 0 0 0-4.167 4.149c0 2.309 1.884 4.185 4.167 4.185a4.166 4.166 0 0 0 4.167-4.185A4.158 4.158 0 0 0 9 1.833z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.633 16a.337.337 0 0 1-.257-.108c-4.333-4.233-11.42-4.233-15.752 0a.361.361 0 0 1-.514 0 .341.341 0 0 1 0-.502c4.627-4.52 12.154-4.52 16.78 0a.342.342 0 0 1 0 .502.401.401 0 0 1-.257.108z"
}));

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6796f5a7.svg";
export { ForwardRef as ReactComponent };